/** @format */
//@ts-nocheck
import { makeApiRequest, getTokenSingleton, setResolution, setTodaysOpenRate, captureEvent, getExch_Exchtype_Scripcode, sortDataforDepth, arrayToCommaString, arrayToSemicolonString, parseChartUrl, getTransactionDetails, adjustYear, onSymbolChange, } from "./helpers";
import { getScripInfoData } from "./Services/scripInfo";
import { papiApi, papiApiOptions, processFeed, getFormattedDate, getPeriod, } from "./Services/fnoApiCall";
import { subscribeOnStream, unsubscribeFromStream } from "./streaming_tv";
import { METHOD_FOR_CHART_SOCKET, OPT_FOR_CHART_SOCKET, SOCKET_SUBSCRIPTION_METHODS, niftyScripInfoData, niftyMarket_holiday_correction, niftyMarketsession_time, niftyMarket_holiday_session, niftySymbolName, niftyTicker, } from "./utils/constant";
import { subscribeToData, unsubscribeDataBySubscriber, } from "./utils/websocketwrapper";
import { init5DepthSocket, subscribeTo5DepthData, unsubscribeDataByScrip5Depth } from "./utils/new_depthwrapper";
import { ScripInfoDetails } from "./main";
import { subscribeToDepthData, initDepthSocket } from "./utils/depthwrapper";
import { opt, callingElasticSearch } from "./Services/elasticSearch";
import { getReport } from "./Services/transactionApiCall";
import { fetchCorporateActionData } from "./Services/corporateAction";
import { createSymbolInfo } from "./Services/symbolnfoProvider";
import { tradingTimeFirebaseConfig } from "./firebase-config";
import { defaultTradeTimeConfiguration } from "./Constants/firebaseDefaultConfigs";
import { indexFundsSymbols } from "./Constants/datafeedConstant";
import { getConfig } from "./config/config";
import loggly_util from "../src/loggly-util";
const { APP_BASE_CHARTSTT_API_URL, APP_BASE_APIHUB_API_URL } = getConfig();
//define constants
const param = new URLSearchParams(location.search);
const ReqUrl = new URL(window.location);
let setMarks = false;
let isTradingTerminal = param.get("isTradeChart");
if (isTradingTerminal == "true") {
    sessionStorage.setItem("sym_search_Tradechart", "false");
    setMarks = true;
}
else {
    sessionStorage.setItem("sym_search_noTradechart", "false");
}
let intervalId = undefined;
let _quotesSubscriptions = new Map();
window.layoutMap = new Map();
let Data;
const lastBarData = new Map();
let token = await getTokenSingleton(localStorage.TokenResponseTv);
let accessToken = "Bearer " + token.access_token;
let localclientCode = localStorage.getItem("ClientCode");
let firstLoad = true;
let tempSymbolInfo;
const configurationData = {
    supports_marks: setMarks,
    supports_timescale_marks: setMarks,
    supports_time: setMarks, //Set this totrue Suppose your datafeed provides server time (unix time). It is used to adjust the price ratio on the time scale.
    // exchanges: ["NSE", "BSE", "MCX"], //An array of exchange names that are supported by your datafeed.
    // symbols_types: [{ name: "All types", value: "Overview" },
    // { name: "futures", value: "futures" },
    // { name: "options", value: "options" }],
};
let urlParameter;
let lastDate;
let searchResults = [];
//let expDateCnt = 0;
let currentResolution;
let intraDaydata = [];
let lengthForIntraDay = 0;
let lenforintraday;
let feedArray = [];
let length = 0;
let len;
let searchSymbolsDebounceTimer; // Store the timer for debounce (Elastic search API)
//corporate action
const CorporateActionDataService = (() => {
    let instance;
    function createInstance() {
        let cachedMarks = {};
        return {
            getCorporateActionMarks: async function (symbolInfo, startDate, endDate) {
                const cacheKey = `${symbolInfo.ticker}-${startDate}-${endDate}`;
                if (!cachedMarks[cacheKey]) {
                    cachedMarks[cacheKey] = await fetchCorporateActionData(symbolInfo, startDate, endDate);
                }
                return cachedMarks[cacheKey];
            },
        };
    }
    return {
        getInstance: function () {
            if (!instance) {
                instance = createInstance();
            }
            return instance;
        },
    };
})();
export default {
    //This variable contains all the url parameters data which can be used throughout the library
    urlParameter: parseChartUrl(window.location.href),
    //This method is used by the Charting Library to get a configuration of your datafeed (e.g. supported resolutions, exchanges and so on).
    //This is the first method of the datafeed that is called.
    onReady: async (callback) => {
        var _a;
        if (ScripInfoDetails == null) {
            console.log("[getBarsParameters]: Get error");
            // return;
        }
        // On Resolution change clearing layoput map for fresh Api Calls
        try {
            (_a = window === null || window === void 0 ? void 0 : window.layoutMap) === null || _a === void 0 ? void 0 : _a.clear();
        }
        catch (err) {
            console.error(err);
        }
        //Our datafeed should return this configuration to the Charting Library. Note, that the callback must be called asynchronously.
        setTimeout(() => callback(configurationData), 0);
    },
    //This method is used by the Charting Library to search symbols every time a user types a text in the symbol search box.Changing symbols also works using the symbol search.
    searchSymbols: async (userInput, exchange, symbolType, onResultReadyCallback) => {
        if (layoutMap.has(userInput)) {
            layoutMap.delete(userInput);
        }
        clearTimeout(searchSymbolsDebounceTimer); // Clear any existing timer
        // Debounce for 500ms in elastic Search API---------------
        searchSymbolsDebounceTimer = setTimeout(async () => {
            let newInput = "";
            for (let i = 0; i < userInput.length; i++) {
                if (userInput[i] === " ") {
                    newInput += "*+";
                }
                else {
                    newInput += userInput[i];
                }
            }
            let searchResults = [];
            if (userInput && userInput.length > 2) {
                try {
                    searchResults = await callingElasticSearch(newInput);
                }
                catch (error) {
                    console.error("Error calling ElasticSearch:", error);
                    onResultReadyCallback([]);
                    return;
                }
            }
            const vp = opt(searchResults);
            onResultReadyCallback(vp);
        }, 500);
    },
    //This method is used by the library to retrieve information about a specific symbol(exchange, price scale, full symbol etc.).
    resolveSymbol: async (symbolName, onSymbolResolvedCallback, ErrorCallback) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45;
        onSymbolChange();
        if (ReqUrl.searchParams.get("isTradeChart") === "false" && ReqUrl.searchParams.get("osName") === "flutter") {
            const isInvalidSymbol = (name) => {
                if (!name || typeof name !== "string")
                    return true;
                const lower = name.toLowerCase();
                return lower.includes("undefined") || lower.includes("nan");
            };
            if (isInvalidSymbol(symbolName)) {
                const fallbackSymbol = sessionStorage.getItem("mob_symboltoWidget");
                if (fallbackSymbol && !isInvalidSymbol(fallbackSymbol)) {
                    symbolName = fallbackSymbol;
                }
            }
        }
        // caling ScripInfo Api -----------------------------------------
        const paramsForScripInfo = getExch_Exchtype_Scripcode(symbolName);
        const ScripInfoData = await getScripInfoData(paramsForScripInfo);
        if (ReqUrl.searchParams.get("isTradeChart") === "false" && ReqUrl.searchParams.get("osName") === "flutter" && ScripInfoData === null) {
            loggly_util.logAdvancedMessage("resolveSymbol_payload", {
                clientCode: localStorage.getItem("ClientCode"),
                ticker: symbolName,
                paramsForScripInfo: paramsForScripInfo,
                ScripInfo: ScripInfoData,
            });
        }
        if (ScripInfoData != null) {
            if (!symbolName.includes(":")) {
                const vpp = opt(searchResults);
                symbolName = vpp[0].full_name;
            }
            const symbolShortName = symbolName.split(":")[1] || symbolName.split("/")[1];
            const [exch, sym] = symbolName.toLowerCase().replace("/", ":").split(":");
            // let sc = symbolName.split("/")[1];
            const tradingTimeMarketSessionConfig = await tradingTimeFirebaseConfig();
            let Marketsession_time = tradingTimeMarketSessionConfig
                ? (_c = (_b = (_a = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _a === void 0 ? void 0 : _a.trading_time) === null || _b === void 0 ? void 0 : _b.market_time) === null || _c === void 0 ? void 0 : _c.equity
                : (_f = (_e = (_d = defaultTradeTimeConfiguration === null || defaultTradeTimeConfiguration === void 0 ? void 0 : defaultTradeTimeConfiguration.trade_time_configuration) === null || _d === void 0 ? void 0 : _d.trading_time) === null || _e === void 0 ? void 0 : _e.market_time) === null || _f === void 0 ? void 0 : _f.equity;
            let Market_holiday_correction = tradingTimeMarketSessionConfig
                ? arrayToSemicolonString((_h = (_g = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _g === void 0 ? void 0 : _g.corrections) === null || _h === void 0 ? void 0 : _h.equity)
                : arrayToSemicolonString((_k = (_j = defaultTradeTimeConfiguration === null || defaultTradeTimeConfiguration === void 0 ? void 0 : defaultTradeTimeConfiguration.trade_time_configuration) === null || _j === void 0 ? void 0 : _j.corrections) === null || _k === void 0 ? void 0 : _k.equity);
            let Market_holiday_session = tradingTimeMarketSessionConfig
                ? arrayToCommaString((_m = (_l = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _l === void 0 ? void 0 : _l.session_holidays) === null || _m === void 0 ? void 0 : _m.equity)
                : arrayToCommaString((_p = (_o = defaultTradeTimeConfiguration === null || defaultTradeTimeConfiguration === void 0 ? void 0 : defaultTradeTimeConfiguration.trade_time_configuration) === null || _o === void 0 ? void 0 : _o.session_holidays) === null || _p === void 0 ? void 0 : _p.equity);
            if (symbolShortName == "NIFTY50" ||
                symbolShortName == "nifty50" ||
                symbolShortName == "Nifty50") {
                symbolName = symbolName.split(":")[0] + ":" + "NIFTY";
            }
            if (ScripInfoData != undefined && ScripInfoData.InstrumentType == null) {
                if ((ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.Exch) == "M" || (ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.ExchType) == "U") {
                    Marketsession_time = tradingTimeMarketSessionConfig
                        ? (_s = (_r = (_q = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _q === void 0 ? void 0 : _q.trading_time) === null || _r === void 0 ? void 0 : _r.market_time) === null || _s === void 0 ? void 0 : _s.commodity
                        : (_v = (_u = (_t = defaultTradeTimeConfiguration === null || defaultTradeTimeConfiguration === void 0 ? void 0 : defaultTradeTimeConfiguration.trade_time_configuration) === null || _t === void 0 ? void 0 : _t.trading_time) === null || _u === void 0 ? void 0 : _u.market_time) === null || _v === void 0 ? void 0 : _v.commodity;
                    Market_holiday_correction = tradingTimeMarketSessionConfig
                        ? arrayToSemicolonString((_x = (_w = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _w === void 0 ? void 0 : _w.corrections) === null || _x === void 0 ? void 0 : _x.commodity)
                        : arrayToSemicolonString((_z = (_y = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _y === void 0 ? void 0 : _y.corrections) === null || _z === void 0 ? void 0 : _z.commodity);
                    Market_holiday_session = tradingTimeMarketSessionConfig
                        ? arrayToCommaString((_1 = (_0 = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _0 === void 0 ? void 0 : _0.session_holidays) === null || _1 === void 0 ? void 0 : _1.commodity)
                        : arrayToCommaString((_3 = (_2 = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _2 === void 0 ? void 0 : _2.session_holidays) === null || _3 === void 0 ? void 0 : _3.commodity);
                    if ((ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.ExchType) == "U") {
                        Marketsession_time = tradingTimeMarketSessionConfig
                            ? (_6 = (_5 = (_4 = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _4 === void 0 ? void 0 : _4.trading_time) === null || _5 === void 0 ? void 0 : _5.market_time) === null || _6 === void 0 ? void 0 : _6.currency
                            : (_9 = (_8 = (_7 = defaultTradeTimeConfiguration === null || defaultTradeTimeConfiguration === void 0 ? void 0 : defaultTradeTimeConfiguration.trade_time_configuration) === null || _7 === void 0 ? void 0 : _7.trading_time) === null || _8 === void 0 ? void 0 : _8.market_time) === null || _9 === void 0 ? void 0 : _9.currency;
                        Market_holiday_correction = tradingTimeMarketSessionConfig
                            ? arrayToSemicolonString((_11 = (_10 = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _10 === void 0 ? void 0 : _10.corrections) === null || _11 === void 0 ? void 0 : _11.currency)
                            : arrayToSemicolonString((_13 = (_12 = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _12 === void 0 ? void 0 : _12.corrections) === null || _13 === void 0 ? void 0 : _13.currency);
                        Market_holiday_session = tradingTimeMarketSessionConfig
                            ? arrayToCommaString((_15 = (_14 = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _14 === void 0 ? void 0 : _14.session_holidays) === null || _15 === void 0 ? void 0 : _15.currency)
                            : arrayToCommaString((_17 = (_16 = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _16 === void 0 ? void 0 : _16.session_holidays) === null || _17 === void 0 ? void 0 : _17.currency);
                    }
                }
                let symbolInfo = createSymbolInfo(ScripInfoData, symbolInfoName, symbolName, Marketsession_time, Market_holiday_correction, Market_holiday_session);
                tempSymbolInfo = symbolInfo;
                localStorage.setItem("scriptCode", symbolInfo.scripCode);
                localStorage.setItem("exchange", exch);
                setTimeout(function () {
                    onSymbolResolvedCallback(JSON.parse(JSON.stringify(symbolInfo)));
                }, 0);
            }
            else if (ScripInfoData != undefined) {
                if ((ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.ExchType) == "U" || (ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.Exch) == "M") {
                    Marketsession_time = tradingTimeMarketSessionConfig
                        ? (_20 = (_19 = (_18 = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _18 === void 0 ? void 0 : _18.trading_time) === null || _19 === void 0 ? void 0 : _19.market_time) === null || _20 === void 0 ? void 0 : _20.commodity
                        : (_23 = (_22 = (_21 = defaultTradeTimeConfiguration === null || defaultTradeTimeConfiguration === void 0 ? void 0 : defaultTradeTimeConfiguration.trade_time_configuration) === null || _21 === void 0 ? void 0 : _21.trading_time) === null || _22 === void 0 ? void 0 : _22.market_time) === null || _23 === void 0 ? void 0 : _23.commodity;
                    Market_holiday_correction = tradingTimeMarketSessionConfig
                        ? arrayToSemicolonString((_25 = (_24 = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _24 === void 0 ? void 0 : _24.corrections) === null || _25 === void 0 ? void 0 : _25.commodity)
                        : arrayToSemicolonString((_27 = (_26 = defaultTradeTimeConfiguration === null || defaultTradeTimeConfiguration === void 0 ? void 0 : defaultTradeTimeConfiguration.trade_time_configuration) === null || _26 === void 0 ? void 0 : _26.corrections) === null || _27 === void 0 ? void 0 : _27.commodity);
                    Market_holiday_session = tradingTimeMarketSessionConfig
                        ? arrayToCommaString((_29 = (_28 = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _28 === void 0 ? void 0 : _28.session_holidays) === null || _29 === void 0 ? void 0 : _29.commodity)
                        : arrayToCommaString((_31 = (_30 = defaultTradeTimeConfiguration === null || defaultTradeTimeConfiguration === void 0 ? void 0 : defaultTradeTimeConfiguration.trade_time_configuration) === null || _30 === void 0 ? void 0 : _30.session_holidays) === null || _31 === void 0 ? void 0 : _31.commodity);
                    if ((ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.ExchType) == "U") {
                        Marketsession_time = tradingTimeMarketSessionConfig
                            ? (_34 = (_33 = (_32 = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _32 === void 0 ? void 0 : _32.trading_time) === null || _33 === void 0 ? void 0 : _33.market_time) === null || _34 === void 0 ? void 0 : _34.currency
                            : (_37 = (_36 = (_35 = defaultTradeTimeConfiguration === null || defaultTradeTimeConfiguration === void 0 ? void 0 : defaultTradeTimeConfiguration.trade_time_configuration) === null || _35 === void 0 ? void 0 : _35.trading_time) === null || _36 === void 0 ? void 0 : _36.market_time) === null || _37 === void 0 ? void 0 : _37.currency;
                        Market_holiday_correction = tradingTimeMarketSessionConfig
                            ? arrayToSemicolonString((_39 = (_38 = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _38 === void 0 ? void 0 : _38.corrections) === null || _39 === void 0 ? void 0 : _39.currency)
                            : arrayToSemicolonString((_41 = (_40 = defaultTradeTimeConfiguration === null || defaultTradeTimeConfiguration === void 0 ? void 0 : defaultTradeTimeConfiguration.trade_time_configuration) === null || _40 === void 0 ? void 0 : _40.corrections) === null || _41 === void 0 ? void 0 : _41.currency);
                        Market_holiday_session = tradingTimeMarketSessionConfig
                            ? arrayToCommaString((_43 = (_42 = tradingTimeMarketSessionConfig === null || tradingTimeMarketSessionConfig === void 0 ? void 0 : tradingTimeMarketSessionConfig.trade_time_configuration) === null || _42 === void 0 ? void 0 : _42.session_holidays) === null || _43 === void 0 ? void 0 : _43.currency)
                            : arrayToCommaString((_45 = (_44 = defaultTradeTimeConfiguration === null || defaultTradeTimeConfiguration === void 0 ? void 0 : defaultTradeTimeConfiguration.trade_time_configuration) === null || _44 === void 0 ? void 0 : _44.session_holidays) === null || _45 === void 0 ? void 0 : _45.currency);
                    }
                }
                var symbolInfoName = (ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.Exch) == "M"
                    ? (ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.Exch) + "" + "CX" + ":" + (ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.Name.replace(/\//g, ' '))
                    : (ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.Exch) + "" + "SE" + ":" + (ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.Name.replace(/\//g, ' '));
                let symbolInfo = createSymbolInfo(ScripInfoData, symbolInfoName, symbolName, Marketsession_time, Market_holiday_correction, Market_holiday_session);
                tempSymbolInfo = symbolInfo;
                localStorage.setItem("scriptCode", symbolInfo.scripCode);
                localStorage.setItem("exchange", exch);
                setTimeout(function () {
                    onSymbolResolvedCallback(JSON.parse(JSON.stringify(symbolInfo)));
                }, 0);
                if (sessionStorage.getItem("chartContentFlag") == "false") {
                }
            }
            else {
                var symbolInfo = tempSymbolInfo;
            }
        }
        else {
            let symbolInfo = createSymbolInfo(niftyScripInfoData.Data, niftySymbolName, niftyTicker, niftyMarketsession_time, niftyMarket_holiday_correction, niftyMarket_holiday_session);
            setTimeout(function () {
                onSymbolResolvedCallback(JSON.parse(JSON.stringify(symbolInfo)));
            }, 0);
        }
    },
    //This method is used by the charting library to get historical data for the symbol.
    getBars: async (symbolInfo, resolution, periodParams, onHistoryCallback, ErrorCallback) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!layoutMap.has(symbolInfo.name)) {
            layoutMap.set(symbolInfo.name, 0);
        }
        const { from, to, firstDataRequest } = periodParams;
        var bars = [];
        setResolution(resolution);
        var feed = [];
        var exchangeType = symbolInfo.exchType;
        let exchange = symbolInfo.exchange;
        if (exchange.toLowerCase() == "nse" || exchange.toLowerCase() == "n")
            exchange = "N";
        else if (exchange.toLowerCase() == "bse" || exchange.toLowerCase() == "b")
            exchange = "B";
        else {
            exchange = "M";
        }
        let fromDate = new Date(0);
        fromDate.setSeconds(from);
        let toDate = new Date(to * 1000).toISOString();
        toDate = toDate.split("T");
        toDate = toDate[0];
        var period = await getPeriod(resolution).toLowerCase();
        var scripCode = symbolInfo.scripCode;
        var resolutionArr = ["1D", "1W"];
        var resolutionInt = 240;
        let param = new URLSearchParams(location.search);
        var indexSymbols = symbolInfo.exchType == "D"
            ? symbolInfo.full_name.split(" ")[0].split(":")[1]
            : symbolInfo.full_name.split("/")[0].split(":")[1];
        if (lastDate && !resolutionArr.includes(resolution))
            fromDate = lastDate;
        fromDate = await getFormattedDate(fromDate);
        if (indexFundsSymbols.includes(indexSymbols.toUpperCase()) ||
            indexFundsSymbols.includes(indexSymbols.toLowerCase())) {
            resolutionArr = ["1D", "1W", "1M"];
            resolutionInt = 240;
        }
        try {
            var dateParam = fromDate.replace(/-/gi, "");
            dateParam.replace(/-/g, "");
            var dataToday;
            if (firstDataRequest)
                dateParam = 0;
            if ((firstDataRequest && firstLoad) ||
                Number(resolution) <= resolutionInt) {
                firstLoad = false;
                var url = `${APP_BASE_CHARTSTT_API_URL}chart/historicalintradayV1/${exchange}/${exchangeType}/${scripCode}/${period}/` +
                    dateParam; //live
                accessToken = "Bearer " + token.access_token;
            }
            else {
                var otpType = "optstk";
                var futType = "futstk";
                if (indexFundsSymbols.includes(indexSymbols.toUpperCase()) ||
                    indexFundsSymbols.includes(indexSymbols.toLowerCase())) {
                    otpType = "optidx";
                }
                if (indexFundsSymbols.includes(indexSymbols.toUpperCase()) ||
                    indexFundsSymbols.includes(indexSymbols.toLowerCase())) {
                    futType = "futidx";
                }
                if (exchangeType === "D" &&
                    exchange !== "M" &&
                    (symbolInfo.type === "futures" || symbolInfo.type === "FUTURES") &&
                    (resolution === "1M" || resolution === "1W" || resolution === "1D")) {
                    if (layoutMap.get(symbolInfo.name) === 0) {
                        await papiApi(symbolInfo, indexFundsSymbols, indexSymbols);
                        const description = symbolInfo.description;
                        const pattern = /([A-Z0-9&-]+(?:\s+[A-Z0-9&-]+)*)\s+(\d+\s+[A-Za-z]+\s+\d{4})/;
                        const matches = description.match(pattern);
                        const symbol = matches[1];
                        let expiryDate = matches[2];
                        expiryDate = expiryDate.replace(/ /g, "-");
                        expiryDate = expiryDate.replace(/,/g, "");
                        if (symbolInfo.exchange == "NSE" ||
                            symbolInfo.exchange == "nse" ||
                            symbolInfo.exchange == "N" ||
                            symbolInfo.exchange == "n") {
                            var url = `${APP_BASE_APIHUB_API_URL}atlas-req1-rt/datamart/Derivative/Derivative.svc/fandohistoricalchartdata/${futType}/${symbol}/${expiryDate}/A/xx/m/3?responsetype=json`;
                        }
                        else {
                            var url = `${APP_BASE_APIHUB_API_URL}atlas-req1-rt/datamart/Derivative/Derivative.svc/BSEfandohistoricalchartdata/${futType}/${symbol}/${expiryDate}/A/xx/m/3?responsetype=json`;
                        }
                        layoutMap.set(symbolInfo.name, 1);
                    }
                }
                else if (exchangeType === "D" &&
                    exchange !== "M" &&
                    (symbolInfo.type === "options" || symbolInfo.type === "OPTIONS") &&
                    (resolution === "1M" || resolution === "1W" || resolution === "1D")) {
                    if (layoutMap.get(symbolInfo.name) === 0) {
                        await papiApiOptions(symbolInfo, indexFundsSymbols, indexSymbols);
                        const description = symbolInfo.description;
                        const pattern = /([A-Z0-9&-]+(?:\s+[A-Z0-9&-]+)*)\s+(\d+\s+[A-Za-z]+\s+\d{4})\s+(CE|PE)\s+(\d+(?:\.\d+)?)/;
                        const matches = description.match(pattern);
                        const symbol = matches[1];
                        const optionType = matches[3];
                        const strikePrice = matches[4];
                        let expiryDate = matches[2];
                        expiryDate = expiryDate.replace(/ /g, "-");
                        expiryDate = expiryDate.replace(/,/g, "");
                        if (symbolInfo.exchange == "NSE" ||
                            symbolInfo.exchange == "nse" ||
                            symbolInfo.exchange == "N" ||
                            symbolInfo.exchange == "n") {
                            var url = `${APP_BASE_APIHUB_API_URL}atlas-req1-rt/datamart/Derivative/Derivative.svc/fandohistoricalchartdata/${otpType}/${symbol}/${expiryDate}/${optionType}/${strikePrice}/m/3?responsetype=json`;
                        }
                        else {
                            var url = `${APP_BASE_APIHUB_API_URL}atlas-req1-rt/datamart/Derivative/Derivative.svc/BSEfandohistoricalchartdata/${otpType}/${symbol}/${expiryDate}/${optionType}/${strikePrice}/m/3?responsetype=json`;
                        }
                        layoutMap.set(symbolInfo.name, 1);
                    }
                }
                else if (resolutionArr.includes(resolution)) {
                    fromDate = await adjustYear(fromDate);
                    accessToken = "Bearer " + token.access_token;
                    var url = `${APP_BASE_CHARTSTT_API_URL}chart/historicalsummaryV1/${exchange}/${exchangeType}/${scripCode}/${period}?from=${fromDate}&end=${toDate}`; //live
                }
            }
            var data = url != undefined
                ? await makeApiRequest(url, {
                    headers: {
                        "Content-Type": "application/json",
                        ...((url.includes("historicalsummaryV1") ||
                            url.includes("historicalintradayV1")) && {
                            authorization: `Bearer ${token.access_token}`,
                        }),
                    },
                })
                : false;
            // Handling when from and to dates are holidays or data is Over for particular scrip. (on Pagination)
            if (((_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.candles) === null || _b === void 0 ? void 0 : _b.length) <= 0 && (url === null || url === void 0 ? void 0 : url.includes("historicalsummaryV1"))) {
                let fromDate_Object = new Date(fromDate);
                let toDate_Object = new Date(toDate);
                fromDate_Object.setDate(fromDate_Object.getDate() - 1);
                toDate_Object.setDate(toDate_Object.getDate() + 1);
                fromDate = await getFormattedDate(fromDate_Object);
                fromDate = await adjustYear(fromDate);
                toDate = await getFormattedDate(toDate_Object);
                var url = `${APP_BASE_CHARTSTT_API_URL}chart/historicalsummaryV1/${exchange}/${exchangeType}/${scripCode}/${period}?from=${fromDate}&end=${toDate}`;
                data =
                    url != undefined
                        ? await makeApiRequest(url, {
                            headers: {
                                "Content-Type": "application/json",
                                ...((url.includes("historicalsummaryV1") ||
                                    url.includes("historicalintradayV1")) && {
                                    authorization: `Bearer ${token.access_token}`,
                                }),
                            },
                        })
                        : false;
            }
            if (data.data &&
                data.data.candles.length &&
                data.data.candles.length > 0) {
                feed = data.data.candles; // intradayV1 and summary v1
            }
            else if (data.body && !!data.body.Data) {
                feed = data.body.Data;
            }
            else if (((_c = data === null || data === void 0 ? void 0 : data.response) === null || _c === void 0 ? void 0 : _c.data) &&
                (((_e = (_d = data.response.data.FNOStockIdentifierList) === null || _d === void 0 ? void 0 : _d.FNOStockIdentifier) === null || _e === void 0 ? void 0 : _e.length) >
                    0 ||
                    ((_f = data.response.data.fandohistoricalchartdatalist) === null || _f === void 0 ? void 0 : _f.recordcount) > 0)) {
                feed =
                    ((_g = data.response.data.FNOStockIdentifierList) === null || _g === void 0 ? void 0 : _g.FNOStockIdentifier.length) >
                        0
                        ? data.response.data.FNOStockIdentifierList.FNOStockIdentifier
                        : ((_h = data.response.data.fandohistoricalchartdatalist) === null || _h === void 0 ? void 0 : _h.recordcount) > 0
                            ? data.response.data.fandohistoricalchartdatalist
                                .fandohistoricalchartdata
                            : [];
                async function getTodaydateFutures() {
                    dataToday = await papiApi(symbolInfo, indexFundsSymbols, indexSymbols);
                    return dataToday;
                }
                async function getTodaydateOptions() {
                    dataToday = await papiApiOptions(symbolInfo, indexFundsSymbols, indexSymbols);
                    return dataToday;
                }
                // if (exchangeType === "D" && symbolInfo.type === "FUTURES") {
                //   dataToday = await getTodaydateFutures();
                // }
                // if (exchangeType === "D" && symbolInfo.type === "OPTIONS") {
                //   dataToday = await getTodaydateOptions();
                // }
                if (dataToday) {
                    dataToday.closeprice = dataToday.LTP || dataToday.ltp;
                    dataToday.openprice = dataToday.OpenPrice || dataToday.openprice;
                    dataToday.highprice = dataToday.HighPrice || dataToday.highprice;
                    dataToday.lowprice = dataToday.LowPrice || dataToday.lowprice;
                    dataToday.volume = dataToday.TradedQtyCnt || dataToday.tradedqtyCnt;
                    dataToday.tradedate = dataToday.UpdTime || dataToday.updtime;
                    dataToday.tradedate = dataToday.tradedate.split(" ");
                    dataToday.tradedate = dataToday.tradedate[0] + " 12:00:00 AM";
                    feed.push(dataToday);
                }
                feed.forEach((ele) => {
                    ele.Close = parseFloat(ele.closeprice);
                    ele.Open = parseFloat(ele.openprice);
                    ele.High = parseFloat(ele.highprice);
                    ele.Low = parseFloat(ele.lowprice);
                    ele.Volume = parseFloat(ele.volume);
                    if (ele.Open == 0) {
                        ele.Open = parseFloat(ele.ltp);
                        ele.High = parseFloat(ele.ltp);
                        ele.Low = parseFloat(ele.ltp);
                    }
                    let timeDate = ele.tradedate.split(" ");
                    ele.Date = timeDate[0] + " " + timeDate[1] + " PM";
                });
            }
            if (firstDataRequest && resolution <= resolutionInt && feed.length > 0) {
                const setOpenRate = feed[0][1];
                setTodaysOpenRate(setOpenRate);
            }
            if (["1M", "1D", "1W"].includes(resolution)) {
                feedArray = [].concat(feed);
                len = feedArray.length;
                length = length + len;
            }
            localStorage.setItem("length", length);
            if (resolution != "1M" || resolution != "1D" || resolution != "1W") {
                intraDaydata = [].concat(feed);
                lenforintraday = intraDaydata.length;
                lengthForIntraDay = lengthForIntraDay + lenforintraday;
            }
            localStorage.setItem("intraDaydata", lengthForIntraDay);
            if (feed.length === 0 && firstDataRequest) {
                onHistoryCallback([], { noData: true });
                layoutMap.set(symbolInfo.name, 0);
                return;
            }
            bars = await processFeed(feed, symbolInfo, resolution);
            let sortedBar = bars.sort((a, b) => a.time - b.time);
            var unique = (src) => [...new Set(src)];
            sortedBar = unique(sortedBar);
            Data = sortedBar;
            if (firstDataRequest) {
                lastBarData.set(symbolInfo.ticker, {
                    ...sortedBar[sortedBar.length - 1],
                });
            }
            if (!resolutionArr.includes(resolution) &&
                sortedBar &&
                sortedBar.length > 0) {
                lastDate = new Date(sortedBar[0].time);
            }
            else {
                lastDate = undefined;
            }
            if (sortedBar.length > 0) {
                if (!(resolution === "1D" &&
                    (symbolInfo.type === "OPTIONS" || symbolInfo.type === "FUTURES"))) {
                    onHistoryCallback(sortedBar, { noData: false });
                }
                else {
                    if (firstDataRequest) {
                        onHistoryCallback(sortedBar, { noData: false });
                    }
                    else {
                        onHistoryCallback([], { noData: true });
                    }
                }
            }
            else {
                onHistoryCallback([], { noData: true });
                //ErrorCallback("no data available");
            }
        }
        catch (error) {
            console.log("[getBars]: Get error", error);
            ErrorCallback("no data available");
        }
    },
    //market depth data update
    subscribeDepth: async (symbol, DOMCallback) => {
        initDepthSocket();
        captureEvent("RHS_Menu_Click", {
            Action: "DOM_Click",
        });
        let result = getExch_Exchtype_Scripcode(symbol);
        if (result.Exch === "N" &&
            (result.ExchType === "C" || result.ExchType === "D")) {
            subscribeToDepthData({
                Method: METHOD_FOR_CHART_SOCKET,
                Operation: SOCKET_SUBSCRIPTION_METHODS.DEPTH_20_SERVICE,
                MarketFeedData: [
                    {
                        Exch: result.Exch,
                        ScripCode: result.ScripCode,
                        ExchType: result.ExchType,
                    },
                ],
            }, "DOMPanel" + result.ScripCode, true, (callbackData) => {
                let DOMdata = [];
                if (callbackData != null) {
                    (DOMdata = {
                        asks: sortDataforDepth(callbackData.Details).askPrice,
                        bids: sortDataforDepth(callbackData.Details).bidPrice,
                        snapshot: true,
                    }),
                        DOMCallback(DOMdata);
                }
            });
        }
        else {
            init5DepthSocket();
            subscribeTo5DepthData({
                ClientCode: localclientCode,
                Method: SOCKET_SUBSCRIPTION_METHODS.DEPTH_SERVICE,
                Operation: METHOD_FOR_CHART_SOCKET,
                MarketFeedData: [
                    {
                        Exch: result.Exch,
                        ScripCode: result.ScripCode,
                        ExchType: result.ExchType,
                    },
                ],
            }, ("DOMPanel" + result.ScripCode), (callbackData) => {
                let DOMData = [];
                DOMData = {
                    asks: sortDataforDepth(callbackData.Details).askPrice,
                    bids: sortDataforDepth(callbackData.Details).bidPrice,
                    snapshot: true,
                };
                DOMCallback(DOMData);
            });
        }
        return symbol;
    },
    //unsubscribe from update market depth data
    unsubscribeDepth: async (subscriberUID) => {
        const symbol = await subscriberUID;
        let result = getExch_Exchtype_Scripcode(symbol);
        // unsubscribeDataBySubscriberM("MarketDepth_Dailog" + result.ScripCode)
        unsubscribeDataByScrip5Depth(("DOMPanel" + result.ScripCode), {
            Exch: result.Exch,
            ScripCode: result.ScripCode,
            ExchType: result.ExchType,
        }, SOCKET_SUBSCRIPTION_METHODS.DEPTH_SERVICE);
        // if (intervalId !== undefined) {
        //   clearTimeout(intervalId);
        //   intervalId = undefined;
        // }
    },
    getQuotes: async (symbols, QuotesCallback, QuotesErrorCallback) => {
        symbols = symbols.filter((symbol) => symbol.includes("/"));
        //watchlist code
        if (param.get("isTradeChart") === "true") {
            if (param.get("ispopOut") !== "true") {
                const watchlistApi = await window.tvWidget.watchList();
                const activeListId = watchlistApi.getActiveListId();
                const currentListItems = watchlistApi.getList(activeListId);
                window.previousLengthHolder = currentListItems;
            }
        }
        symbols.forEach((name) => {
            var myCheckInterval = setInterval(async () => {
                let data = [];
                let result = getExch_Exchtype_Scripcode(name);
                subscribeToData({
                    Method: OPT_FOR_CHART_SOCKET,
                    Operation: METHOD_FOR_CHART_SOCKET,
                    MarketFeedData: [
                        {
                            Exch: result.Exch,
                            ScripCode: result.ScripCode,
                            ExchType: result.ExchType,
                        },
                    ],
                }, "GetQuotes" + result.ScripCode, (barData) => {
                    if (barData != null) {
                        let ch = barData.LastRate - barData.PClose;
                        let chp = ((barData.LastRate - barData.PClose) / barData.PClose) * 100;
                        data.push({
                            n: name,
                            s: "ok",
                            v: {
                                short_name: result.symbol,
                                ch: ch == undefined ? 0 : Number(ch),
                                chp: chp == undefined ? 0 : Number(chp),
                                lp: barData != null ? barData.LastRate : 0,
                                ask: barData != null ? barData.OffRate : 0,
                                bid: barData != null ? barData.BidRate : 0,
                                spread: (barData != null ? barData.BidRate : 0) !== 0 &&
                                    (barData != null ? barData.OffRate : 0) !== 0
                                    ? (barData != null ? barData.OffRate : 0) -
                                        (barData != null ? barData.BidRate : 0)
                                    : 0,
                                open_price: barData != null ? barData.OpenRate : 0,
                                high_price: barData != null ? barData.High : 0,
                                low_price: barData != null ? barData.Low : 0,
                                prev_close_price: barData != null ? barData.PClose : 0,
                                original_name: result.symbol,
                                volume: barData != null ? barData.TotalQty : 0,
                            },
                        });
                        unsubscribeDataBySubscriber("GetQuotes" + result.ScripCode);
                        QuotesCallback(data);
                        clearInterval(myCheckInterval);
                    }
                });
            }, 1000);
        });
    },
    subscribeQuotes: async (symbols, fastSymbols, onRealtimeCallback, listenerGUID) => {
        symbols = symbols.filter((symbol) => symbol.includes("/"));
        symbols.forEach((name) => {
            let updateData;
            let resultSubs = getExch_Exchtype_Scripcode(name);
            subscribeToData({
                Method: OPT_FOR_CHART_SOCKET,
                Operation: METHOD_FOR_CHART_SOCKET,
                MarketFeedData: [
                    {
                        Exch: resultSubs.Exch,
                        ScripCode: resultSubs.ScripCode,
                        ExchType: resultSubs.ExchType,
                    },
                ],
            }, listenerGUID, (barData) => {
                if (barData != null) {
                    // const ltpDiv = document.getElementById(`ltp-${barData.Token}`);
                    //  if (ltpDiv) {
                    //      ltpDiv.textContent = (barData.LastRate.toFixed(2));
                    //  }
                    var ch = barData.LastRate - barData.PClose;
                    var chp = ((barData.LastRate - barData.PClose) / barData.PClose) * 100;
                    updateData = [
                        {
                            s: "ok",
                            n: name,
                            v: {
                                short_name: resultSubs.symbol,
                                ask: barData != null ? barData.OffRate : 0,
                                bid: barData != null ? barData.BidRate : 0,
                                ch: ch == undefined ? 0 : Number(ch),
                                chp: chp == undefined ? 0 : Number(chp),
                                lp: barData != null ? barData.LastRate : 0,
                                spread: (barData != null ? barData.BidRate : 0) !== 0 &&
                                    (barData != null ? barData.OffRate : 0) !== 0
                                    ? (barData != null ? barData.OffRate : 0) -
                                        (barData != null ? barData.BidRate : 0)
                                    : 0,
                                open_price: barData != null ? barData.OpenRate : 0,
                                high_price: barData != null ? barData.High : 0,
                                low_price: barData != null ? barData.Low : 0,
                                prev_close_price: barData != null ? barData.PClose : 0,
                                original_name: resultSubs.symbol,
                                volume: barData != null ? barData.TotalQty : 0,
                            },
                        },
                    ];
                    onRealtimeCallback(updateData);
                }
            });
        });
    },
    //Corporate Action
    getTimescaleMarks: async function (symbolInfo, startDate, endDate, onDataCallback, resolution) {
        try {
            const marks = await CorporateActionDataService.getInstance().getCorporateActionMarks(symbolInfo, startDate, endDate);
            // Use empty array as fallback if marks is undefined or null
            const validMarks = marks || [];
            // Map through validMarks to process data
            const formattedMarks = validMarks.map((mark) => {
                return {
                    id: mark.id,
                    time: mark.time,
                    color: mark.color,
                    label: mark.label,
                    tooltip: mark.tooltip, // Assuming tooltip is an array
                };
            });
            onDataCallback(formattedMarks);
        }
        catch (error) {
            onDataCallback([]); // Callback with an empty array in case of error
        }
    },
    //Transaction on chart
    getMarks: async function (symbolInfo, startDate, endDate, onDataCallback, resolution) {
        var _a;
        if (symbolInfo.type === "INDICE") {
            return;
        }
        let selectedTransactionType = localStorage.getItem("selectedTransactionType");
        let TransactionButtonFlag = localStorage.getItem("TransactionButtonFlag");
        let isinNumber;
        let stockType;
        let generatedScrip;
        let transactionType;
        if (TransactionButtonFlag !== "true") {
            return;
        }
        const isDaily = resolution === "1D";
        const isWeeklyOrMonthly = resolution === "1W" || resolution === "1M";
        if (isWeeklyOrMonthly) {
            onDataCallback([]);
            return;
        }
        stockType =
            selectedTransactionType === "Intraday"
                ? 2
                : selectedTransactionType === "Delivery"
                    ? 1
                    : 1;
        const transactionDetails = await getTransactionDetails(symbolInfo, startDate, endDate);
        isinNumber = transactionDetails.isinNumber;
        generatedScrip = transactionDetails.generatedScrip;
        transactionType = transactionDetails.transactionType;
        //API call For Transactions
        try {
            const resultDemo = await getReport(startDate, stockType, isinNumber, generatedScrip, transactionType);
            if (resultDemo.ErrorCode !== 0 || !((_a = resultDemo.DataSet) === null || _a === void 0 ? void 0 : _a.Table)) {
                onDataCallback([]);
                return;
            }
            const singleTransaction = resultDemo.DataSet.Table;
            if (singleTransaction.length === 0) {
                onDataCallback([]);
                return;
            }
            const marks = singleTransaction.map((transaction) => {
                const transactionDate = new Date(transaction.dateoftransaction);
                const utcEpochTime = Math.floor(transactionDate.getTime() / 1000);
                const offsetSeconds = 5.5 * 60 * 60;
                const localEpochTime = utcEpochTime + offsetSeconds;
                let iconTime = localEpochTime;
                return {
                    id: transaction.transactionnumber,
                    time: iconTime,
                    color: transaction.TransactonType === "Buy" ? "green" : "red",
                    text: `${transaction.TransactonType === "Buy" ? "Bought" : "Sold"} ${transaction.quantity} Qty Price ${transaction.price} Rs`,
                    label: transaction.TransactonType === "Buy" ? "B" : "S",
                    labelFontColor: "white",
                    minSize: 25,
                };
            });
            onDataCallback(marks);
        }
        catch (error) {
            console.error("Error in getMarks:", error);
            onDataCallback([]);
        }
    },
    unsubscribeQuotes: (listenerGUID) => {
        clearInterval(_quotesSubscriptions[listenerGUID]);
    },
    subscribeBars: (symbolInfo, resolution, onRealtimeCallback, subscribeUID, onResetCacheNeededCallback) => {
        subscribeOnStream(symbolInfo, resolution, onRealtimeCallback, subscribeUID, onResetCacheNeededCallback, lastBarData.get(symbolInfo.ticker));
    },
    unsubscribeBars: (subscriberUID) => {
        unsubscribeFromStream(subscriberUID);
    },
};
